export const formatResponse = response => ({
  ...response,
  data: {
    ...response.data,
    data: (response?.data?.data ?? []).map(item => ({
      ...item,
      details: { subject: item.subject ?? null, preview: item.preview ?? null }
    }))
  }
});
